/**
 * Telemetry types — shared between client and server.
 *
 * LogCategory enumerates all domain-specific event categories.
 * Used for consistent tagging across Application Insights.
 */

// ---------------------------------------------------------------------------
// LogCategory — 27+ domain categories
// ---------------------------------------------------------------------------

export enum LogCategory {
  // App lifecycle
  APP_START = "APP_START",
  APP_RESUME = "APP_RESUME",
  APP_PAUSE = "APP_PAUSE",
  APP_ERROR = "APP_ERROR",

  // Auth
  AUTH_LOGIN = "AUTH_LOGIN",
  AUTH_LOGOUT = "AUTH_LOGOUT",
  AUTH_TOKEN = "AUTH_TOKEN",
  AUTH_ERROR = "AUTH_ERROR",

  // Dexie Cloud
  DEXIE_SYNC = "DEXIE_SYNC",
  DEXIE_ERROR = "DEXIE_ERROR",
  DEXIE_OPERATION = "DEXIE_OPERATION",

  // Push / Notifications
  PUSH_RECEIVED = "PUSH_RECEIVED",
  PUSH_REGISTER = "PUSH_REGISTER",
  PUSH_ERROR = "PUSH_ERROR",
  PUSH_TOKEN = "PUSH_TOKEN",

  // Reminders
  REMINDER_SCHEDULE = "REMINDER_SCHEDULE",
  REMINDER_TRIGGER = "REMINDER_TRIGGER",
  REMINDER_ERROR = "REMINDER_ERROR",

  // Background
  BACKGROUND_TASK = "BACKGROUND_TASK",
  BACKGROUND_WAKE = "BACKGROUND_WAKE",
  BACKGROUND_ERROR = "BACKGROUND_ERROR",

  // API
  API_REQUEST = "API_REQUEST",
  API_RESPONSE = "API_RESPONSE",
  API_ERROR = "API_ERROR",

  // User
  USER_ACTION = "USER_ACTION",
  USER_NAVIGATION = "USER_NAVIGATION",

  // System
  PERFORMANCE = "PERFORMANCE",
  DEBUG = "DEBUG",
  DIAGNOSTIC = "DIAGNOSTIC",
  INFO = "INFO",
  WARNING = "WARNING",
  ERROR = "ERROR",
}

// ---------------------------------------------------------------------------
// Severity levels
// ---------------------------------------------------------------------------

export enum SeverityLevel {
  Verbose = 0,
  Information = 1,
  Warning = 2,
  Error = 3,
  Critical = 4,
}

// ---------------------------------------------------------------------------
// Standard dimensions attached to all events
// ---------------------------------------------------------------------------

export interface StandardDimensions {
  platform: string
  appVersion: string
  userId?: string
  sessionId: string
  deviceId?: string
}

// ---------------------------------------------------------------------------
// Telemetry event payload
// ---------------------------------------------------------------------------

export interface TelemetryEvent {
  name: string
  category: LogCategory
  properties?: Record<string, string | number | boolean | undefined>
  measurements?: Record<string, number>
}
